import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { morgansClient } from '../../../lib/connect/clients';
const OPPORTUNITIES_KEY = [
    'canonicalOpportunities'
];
const noticeLinksKey = (noticeId)=>[
        'canonicalOpportunities',
        'links',
        noticeId
    ];
/** Every canonical Opportunity of the caller's tenant (SAD-469). */ export function useCanonicalOpportunities(enabled = true) {
    return useQuery({
        queryKey: OPPORTUNITIES_KEY,
        queryFn: async ()=>(await morgansClient.listCanonicalOpportunities({})).opportunities,
        enabled
    });
}
/** Create a canonical Opportunity with a title and no Notice. */ export function useCreateCanonicalOpportunity() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (title)=>{
            const response = await morgansClient.createCanonicalOpportunity({
                title
            });
            return response.opportunity;
        },
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: OPPORTUNITIES_KEY
            })
    });
}
/** Opportunities linked to a Notice, with titles resolved from the tenant's list. */ export function useNoticeCanonicalLinks(noticeId) {
    const { data: opportunities } = useCanonicalOpportunities();
    const query = useQuery({
        queryKey: noticeLinksKey(noticeId),
        queryFn: ()=>morgansClient.listCanonicalOpportunityNoticeLinks({
                noticeId
            })
    });
    const titles = new Map((opportunities ?? []).map((o)=>[
            o.id,
            o.title
        ]));
    const linked = (query.data?.links ?? []).map((link)=>({
            linkId: link.id,
            opportunityId: link.opportunityId,
            title: titles.get(link.opportunityId) ?? link.opportunityId
        }));
    return {
        linked,
        isLoading: query.isLoading || opportunities === undefined,
        error: query.error
    };
}
/** Link / unlink a Notice to a canonical Opportunity. Linking a live pair is idempotent. */ export function useNoticeLinkMutations(noticeId) {
    const queryClient = useQueryClient();
    const invalidate = ()=>queryClient.invalidateQueries({
            queryKey: noticeLinksKey(noticeId)
        });
    const link = useMutation({
        mutationFn: (opportunityId)=>morgansClient.linkCanonicalOpportunityNotice({
                opportunityId,
                noticeId
            }),
        onSettled: invalidate
    });
    const unlink = useMutation({
        mutationFn: (opportunityId)=>morgansClient.unlinkCanonicalOpportunityNotice({
                opportunityId,
                noticeId
            }),
        onSettled: invalidate
    });
    return {
        link,
        unlink
    };
}
